var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "deliveryChannelManagement"
    }
  }, [_c("a-card", {
    staticClass: "content",
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.add();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.add")) + " ")])], 1)], 1), _c("a-table", {
    attrs: {
      rowKey: "id",
      loading: _vm.isTableLoading,
      "data-source": _vm.dataList,
      pagination: false
    }
  }, [_c("a-table-column", {
    attrs: {
      ellipsis: "true",
      "data-index": "channelTitle",
      width: "30%",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(text))])], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.name")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      "data-index": "channelType",
      width: "10%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [text === 0 ? [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.dateTime")) + " ")] : text === 1 ? [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.time")) + " ")] : _vm._e()];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.receivingTimeType")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deliveryChannelManagement.receivingTimeTypeToolTip")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      title: _vm.$t("deliveryChannelManagement.productQuantity"),
      "data-index": "goodsNum",
      align: "right",
      width: "8%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [[_vm._v(" " + _vm._s(text) + " ")]];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("deliveryChannelManagement.status"),
      "data-index": "channelStatus",
      align: "left",
      width: "7%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [text === 0 ? [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.disable")))])] : text === 1 ? [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.enable")))])] : _vm._e()];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("deliveryChannelManagement.updateTime"),
      "data-index": "lastUpdateTime",
      align: "left",
      width: "15%"
    }
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("deliveryChannelManagement.operation"),
      align: "left",
      width: "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a", {
          on: {
            click: function click($event) {
              return _vm.editBtn(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), record.channelStatus === 1 ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.sureStop"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.onUpdateStatus(record.id, 0, record);
            }
          }
        }, [record.channelStatus === 1 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.disable")))]) : _vm._e()]) : _vm._e(), record.channelStatus === 0 ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.sureEnable"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.onUpdateStatus(record.id, 1, record);
            }
          }
        }, [record.channelStatus === 0 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.enable")))]) : _vm._e()]) : _vm._e(), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("deliveryChannelManagement.deletePromp"),
            "ok-text": _vm.$t("deliveryChannelManagement.confirm"),
            "cancel-text": _vm.$t("deliveryChannelManagement.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.onUpdateStatus(record.id, 2, record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.delete")))])])];
      }
    }])
  })], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      centered: true,
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.datavalue
    }
  }, [_vm._l(_vm.datavalue.langDataList, function (item, index) {
    return [item.required ? [_c("a-form-model-item", {
      attrs: {
        label: item.titleName,
        prop: "langDataList." + index + ".title",
        rules: [{
          required: true,
          message: _vm.nameErr,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("deliveryChannelManagement.pleaseEnter"),
        maxLength: 100
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: item.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("deliveryChannelManagement.pleaseEnter"),
        maxLength: 100
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1)]];
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deliveryChannelManagement.receivingTimeType")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.datavalue.channelType,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "channelType", $$v);
      },
      expression: "datavalue.channelType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.dateTime")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.time")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deliveryChannelManagement.remark")
    }
  }, [_c("a-textarea", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("deliveryChannelManagement.pleaseEnter"),
      rows: 3,
      maxLength: 255
    },
    model: {
      value: _vm.datavalue.note,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "note", $$v);
      },
      expression: "datavalue.note"
    }
  })], 1)], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.cancel")))]), _vm.dialogStatus == "create" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.confirm")))]) : _vm._e(), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.update();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("deliveryChannelManagement.confirm")))]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };